import { memo, useState } from "react";
import { Switch, Tooltip } from "@mui/material";
import { useIntl } from "../../contexts/IntlContext";
import ConfirmDialog from "../ConfirmDialog";

type StatusToggleProps = {
  checked: boolean;
  disabled?: boolean;
  tooltip?: string;
  ariaLabel?: string;
  confirmTitle?: string;
  confirmMessage?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  /** Opcional — mantém o tamanho padrão do MUI (medium) quando omitido, pra não afetar telas existentes. */
  size?: "small" | "medium";
  onToggle: () => void;
};

const StatusToggle = memo(function StatusToggle({
  checked,
  disabled,
  tooltip,
  ariaLabel,
  confirmTitle,
  confirmMessage,
  confirmLabel,
  cancelLabel,
  size,
  onToggle,
}: StatusToggleProps) {
  const intl = useIntl();
  const [confirmOpen, setConfirmOpen] = useState(false);

  const switchNode = (
    <span>
      <Switch
        checked={!!checked}
        size={size}
        onChange={() => {
          if (confirmTitle) {
            setConfirmOpen(true);
          } else {
            onToggle();
          }
        }}
        disabled={disabled}
        inputProps={{
          "aria-label": ariaLabel || tooltip || "",
        }}
      />
    </span>
  );

  return (
    <>
      {tooltip ? <Tooltip title={tooltip}>{switchNode}</Tooltip> : switchNode}

      {confirmTitle && (
        <ConfirmDialog
          open={confirmOpen}
          title={confirmTitle}
          message={confirmMessage}
          confirmLabel={confirmLabel || intl.formatMessage({ id: "common.confirm" })}
          cancelLabel={cancelLabel || intl.formatMessage({ id: "common.cancel" })}
          onClose={() => setConfirmOpen(false)}
          onConfirm={() => {
            setConfirmOpen(false);
            onToggle();
          }}
        />
      )}
    </>
  );
});

export default StatusToggle;
